//import { store } from "@store";
//import axios from "axios";
//import { apiGeeAuthentication } from "./apiGeeAuthentication";
//import { GEARS_TOKEN } from "@constants";

//const httpClient = axios.create({
//  baseURL: process.env.REACT_APP_API_URL,
//});

//httpClient.interceptors.request.use((config) => {
//  apiGeeAuthentication();
//  const { user } = store.getState();
//  const gearsToken = sessionStorage.getItem(GEARS_TOKEN);
//  const headers = Object.assign(config, {
//    headers: {
//      Authorization: `Bearer ${gearsToken}`,
//      "X-directory-token": `${user?.access_token}`,
//      "X-gears-token": `${user?.id_token}`,
//    },
//  });

//    console.log("these are the headers: ", headers);
//    console.log("these are the config: ", config);

//  return user ? headers : config;
//});

//export { httpClient };

import { store } from "@store";
import axios from "axios";
import {
  apiGeeAuthentication,
  isTokenExpiratedOrNull,
} from "./apiGeeAuthentication";
import { GEARS_TOKEN, ID_TOKEN } from "@constants";
import jwt_decode from "jwt-decode";

const PUBLIC_AUTHENTICATION_PATHS = ["/api/v1/entra/auth"];

const isPublicAuthenticationRequest = (url?: string): boolean =>
  url !== undefined &&
  PUBLIC_AUTHENTICATION_PATHS.some((path) => url.split("?")[0].endsWith(path));

//console.log("REACT_APP_API_URLnv:" + process.env.REACT_APP_API_URL?.toString());
const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axios.interceptors.request.use(
  (response) => {
    //console.log("response:"+response);
    checkIfIdTokenExpired();
    return response;
  },
  (error) => {
    //console.log("error.response.status:"+error.response.status);
    checkIfIdTokenExpired();
    if (error.response && error.response.status === 401) {
      //console.log("intercept request redirect");
      window.location.href = `/login/r${window.location.pathname}`;
    } else {
      return Promise.reject(error);
    }
  }
);

const checkIfIdTokenExpired = () => {
  const idToken = sessionStorage.getItem(ID_TOKEN);
  //console.info("checkIfIdTokenExpired------------");
  if (idToken) {
    const decodedIdToken: any = jwt_decode(idToken);
    //console.log("decodedIdToken.exp: "+decodedIdToken.exp);
    //console.log("less than 1 hr: "+(new Date().getTime() / 1000));
    if (decodedIdToken.exp < new Date().getTime() / 1000) {
      //console.info("checkIfIdTokenExpired true redirect");
      window.location.href = `/login/r${window.location.pathname}`;
    }
  }
};

httpClient.interceptors.request.use(
  async (config) => {
    if (isPublicAuthenticationRequest(config.url)) {
      return config;
    }

    await apiGeeAuthentication();

    const { user } = store.getState();
    checkIfIdTokenExpired();
    if (isTokenExpiratedOrNull()) {
      //console.log("token exipired");
      return Promise.reject(new Error("Token expired."));
    }
    const gearsToken = sessionStorage.getItem(GEARS_TOKEN);
    const identityToken = user?.id_token || sessionStorage.getItem(ID_TOKEN);
    // Added variable for X-directory-token header
    const Xdirectory = user?.provider === "google" ? user.access_token : "na";
    const headers = Object.assign(config, {
      headers: {
        Authorization: `Bearer ${gearsToken}`,
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json;",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        "X-Content-Type-Options": "nosniff",
        "X-Frame-Options": "DENY",
        Expires: "0",
        ...(identityToken && {
          "X-gears-token": identityToken,
        }),
        ...(user && {
          "X-directory-token": Xdirectory,
          "x-idp-provider": user.provider,
        }),
      },
    });
    return headers;
  },
  (error) => {
    Promise.reject(error);
  }
);

export { httpClient };
